import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../../components/Converter";
import KiloNewtonDividedByMillimetre from "../../../../../../components/Math/Units/Metric/KiloNewtonDividedByMillimetre";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function Fliessdruck({ fliessdruck = 0 }) {
  const { t } = useTranslation("translation");
  const q_y_Formula = `\\displaystyle q_{y} = k_{c} \\cdot D_{c} \\cdot \\frac{c_{u,k}}{\\gamma_{cu}}`;
  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.Verification.flowPressureLateralBedding")}</p>}
      indicesValue={
        <span>
          q<sub>y</sub>
        </span>
      }
      formulaValue={<ToolTip id={"q_y_Formula"} type={IconType.FORMULA} formula={q_y_Formula} />}
      inputValue={<span className="input">{ConvertToString(fliessdruck, 4)}</span>}
      unitValue={<KiloNewtonDividedByMillimetre />}
    />
  );
}

export default Fliessdruck;
